export function createQoEObject(
  bitrate: number,
  startuptime: number,
  fps: number,
  droppedFrames: number
) {
  return {
    'media.qoe.bitrate': bitrate,
    'media.qoe.droppedFrames': droppedFrames,
    'media.qoe.framesPerSecond': fps,
    'media.qoe.timeToStart': startuptime,
  };
}
